import { useRef } from 'react';
import { useEventCallback } from '@thimble/utility';

const useDebounce = (fn: () => void, wait = 1000): [() => void, () => void] => {
  const timeoutRef = useRef<NodeJS.Timeout>();
  const reset = useEventCallback(() => timeoutRef.current && clearTimeout(timeoutRef.current));
  const trigger = useEventCallback(() => {
    reset();
    timeoutRef.current = setTimeout(fn, wait);
  });
  return [trigger, reset];
};

export default useDebounce;
